import React          from "react";
import { Typography } from "@mui/material";

const component = props => {
	const {
		title,
		className,
		variant,
		component = "p",
		color,
		onClick = () => {}
	} = props;

	return (
		<Typography
			className = { className }
			color     = { color }
			component = { component }
			onClick   = { onClick }
			variant   = { variant }
		>
			{ title }
		</Typography>
	);
};

export default component;
